<template>
	<div class="layout-flex">
        <div class="notification__con" :class="{ active: notification.show }">
			<base-notification :class="{ active: notification.show }"/>
		</div>
        <slot name="header"></slot>
        <div class="flex-item-content">
            <div class="image-header-wrapper">
                <img class="logo"
                    width="70"
                    height="50"
                    alt="rxc logo"
                    :src="require('@/assets/images/peakpursuits-logo.png')"
                />
            </div>
            <slot name="content"></slot>
        </div>
    </div>
</template>

<script>
import { useStore } from "vuex";
export default {
	name: "LayoutLanding",
	data() {
		return {};
	},
	computed: {
        notification(){
            const store = useStore();
            return store.state.notification;
        }
    },
};
</script>

<style scoped lang="scss">
    .notification__con {
        min-width: 288px;
        position: fixed;
        left: 50%;
        top: 56px;
        transform: translateX(-50%);
        z-index: 100000;
        width: 100%;
        &:not(.active) {
            pointer-events: none;
        }

        .notification {
            width: 100%;
            margin: 0 auto;
            opacity: 0;
            transition: all 0.5s;

            &.active {
                opacity: 100%;
            }
        }
    }
    .layout-flex {
        width: 100%;
        height: 100%;
        display: flex;
        position: relative;

        .flex-item-image {
            flex: 2;
            width: 100%;
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .flex-item-content {
            width: 100%;
            height: 100%;
            flex: 1;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            // max-width: 400px;
            .image-header-wrapper {
                position: relative;
                width: 100%;
                display: flex;
                justify-content: center;
                margin-bottom: 24px;
                padding: 20px;
                background: $secondary-color-20;
            }
            .logo {
                object-fit: contain;
                display: block;
            }
        }
    }
    .img-desktop {
        display: none;
        max-width: 0;
        overflow: hidden;
    }
    @media (min-width: 672px){
        .img-mobile {
            display: none;
            max-width: 0;
            overflow: hidden;
        }
        .img-desktop {
            display: block;
            max-width: unset;
        }
    }
    @media (min-width: 672px) and (max-width: 1024px){
        .img-mobile {
            display: block !important;
            max-width: unset !important;
        }
        .img-desktop {
            display: none !important;
            max-width: 0 !important;
            overflow: hidden;
        }
    }
    @media (max-width: 800px) {
        .layout-flex {
            flex-direction: column;
            .flex-item-image {
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
        }
    }
</style>
